<div class="lock-ovh">
  <div class="cooking-story-header" [ngClass]="{ shadow: shadowNav }">
    <div class="search-box">
      <img
        src="assets/cookingbook/search.svg"
        *ngIf="!isSearch"
        class="icon"
        alt=""
      />
      <img
        src="assets/cookingbook/search_blue.svg"
        *ngIf="isSearch"
        class="icon"
        alt=""
      />

      <input
        type="text"
        [(ngModel)]="searchText"
        (keydown)="onkeydown($event)"
        (ngModelChange)="search($event)"
        autofocus
        autocomplete="off"
        placeholder="جست و جوی غذای مورد نظر "
      />
      <img
        src="assets/cookingbook/clear.svg"
        *ngIf="isSearch"
        (click)="clear()"
        class="clear"
        alt=""
      />
    </div>
    <div class="cancel" (click)="goBack()">لغو</div>
  </div>

  <div class="typing" *ngIf="showTyping && !isSearch">
    <ng-lottie
      width="160px"
      height="93px"
      [options]="options"
      [containerClass]="'lottie'"
      (animationCreated)="animationCreated($event)"
    ></ng-lottie>
    <p class="lottie-title">غذا مورد نظر خود را تایپ کنید</p>
  </div>
  <div class="notFound" *ngIf="showNotFound">
    <ng-lottie
      width="160px"
      height="93px"
      [options]="options2"
      [containerClass]="'lottie'"
      (animationCreated)="animationCreated($event)"
    ></ng-lottie>
    <p class="lottie-title">غذا مورد نظر پیدا نشد</p>
  </div>
  <div
    class="cooking-story-body"
    *ngIf="searchedFood && isSearch"
    (scroll)="scrolling($event)"
    #scroolEl
    [ngClass]="{ last: searchedFood.length % 2 !== 0 }"
  >
    <div *ngFor="let recipe of searchedFood" (click)="openRecipe(recipe._id)">
      <div
        class="recipe-box recipe-item recipe-shadow"
        [ngStyle]="{
          'background-image': 'url(' + recipe?.image + ')',
          'background-position': 'center center',
          'background-repeat': 'no-repeat'
        }"
      >
        <div class="label">
          <P class="pl-5">
            {{ recipe?.impressions }}
          </P>
          <img src="assets/cookingbook/heart.svg" alt="" />
        </div>
        <img
          class="play-icon"
          *ngIf="recipe?.video"
          src="assets/cookingbook/play.svg"
          alt=""
        />
      </div>
      <p class="recipe-name">
        {{ recipe?.name }}
      </p>
    </div>
  </div>
</div>
<div [ngClass]="{ show: sending && isSearch }" *ngIf="sending && isSearch " class="loading">
  <svg class="splash-spinner" viewBox="0 0 50 50">
    <circle
      class="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="5"
    ></circle>
  </svg>
</div>
